export default "__VITE_ASSET__DUkRDHzb__"